import React, {useState} from 'react';
import './ActionButton.css';
import AbonneForm from './../../forms/AbonneForm';
import ServiceForm from './../../forms/ServiceForm';
import AdminForm from './../../forms/AdminForm';
import StructureForm from '../../forms/StructureForm';
import CarteForm from '../../forms/CarteForm';

function ActionButton() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isServiceModalOpen, setIsServiceModalOpen] = useState(false);
  const [isAdminModalOpen, setIsAdminModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleOpenAdminModal = () => {
    setIsAdminModalOpen(true);
  };

  const handleOpenServiceModal = () => {
    setIsServiceModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setIsServiceModalOpen(false);
    setIsAdminModalOpen(false);
  };

  return (
    <div className='btn-container'>
        <p>Action rapides pour l'administrateur</p>
        <hr className="separator" />
        <div className="btn-action">
            <button className="inscription" onClick={handleOpenModal}>Ajouter une structure</button>
            <button className="validation" onClick={handleOpenAdminModal}>Créer une carte</button>
            <button className="suppression" onClick={handleOpenServiceModal}>Ajouter une institutions</button>
        </div>

        {/* Modal pour Ajouter une institution */}
      {isModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <button className="close-button" onClick={handleCloseModal}>
              &times;
            </button>
            <h2>Ajouter une institution</h2>
            <StructureForm />
          </div>
        </div>
      )}

      {/* Modal pour Ajouter une structure */}
      {isServiceModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <button className="close-button" onClick={handleCloseModal}>
              &times;
            </button>
            <h2>Ajouter une structure</h2>
            <ServiceForm />
          </div>
        </div>
      )}

      {/* Modal pour Créer une carte */}
      {isAdminModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <button className="close-button" onClick={handleCloseModal}>
              &times;
            </button>
            <h2>Créer une carte</h2>
            <CarteForm />
          </div>
        </div>
      )}

    </div>
  )
}

export default ActionButton